
import React from 'react';
import { LocationSuggestion } from '@/src/types';

interface SuggestionDropdownProps {
  hub: 'launchpad' | 'discovery' | 'locality';
  isFetchingSuggestions: boolean;
  locSuggestions: LocationSuggestion[];
  onSelect: (name: string) => void;
  onClose: () => void;
}

const SuggestionDropdown: React.FC<SuggestionDropdownProps> = ({ 
  hub, 
  isFetchingSuggestions, 
  locSuggestions, 
  onSelect, 
  onClose 
}) => {
  if (!isFetchingSuggestions && locSuggestions.length === 0) return null;
  return (
    <div className="absolute left-0 right-0 top-full mt-2 bg-[#3a3430] border border-white/[0.08] rounded-xl shadow-2xl z-[150] overflow-hidden animate-in fade-in slide-in-from-top-2">
      <div className="p-3 bg-[#322D29] border-b border-white/[0.06] flex items-center justify-between">
        <div className="flex items-center gap-3">
          {isFetchingSuggestions ? (
            <>
              <div className="w-3 h-3 border-2 border-[#F26522]/20 border-t-[#F26522] rounded-full animate-spin"></div>
              <span className="text-[10px] font-bold uppercase tracking-widest text-[#F26522]">Syncing Node...</span>
            </>
          ) : (
            <span className="text-[10px] font-bold uppercase tracking-widest text-white/50">Suggestions</span>
          )}
        </div>
        <button 
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); onClose(); }}
          className="w-6 h-6 flex items-center justify-center text-white/40 hover:text-white transition-colors cursor-pointer rounded hover:bg-white/5"
        >
          <i className="fas fa-times text-[10px]"></i>
        </button>
      </div>
      <div className="max-h-60 overflow-y-auto no-scrollbar">
        {locSuggestions.map((s, i) => {
          if (!s || !s.name) return null;
          return (
          <button
            key={`suggestion-${i}-${s.name}`}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); onSelect(s.name); }}
            className="w-full text-left p-3.5 hover:bg-white/5 transition-colors border-b border-white/[0.04] last:border-0 group cursor-pointer"
          >
            <div className="flex items-center gap-3.5">
              <div className="w-7 h-7 rounded-lg bg-[#322D29] border border-white/[0.06] flex items-center justify-center text-white/50 group-hover:text-[#F26522] group-hover:border-[#F26522]/40 transition-colors shrink-0">
                <i className="fas fa-location-dot text-[11px]"></i>
              </div>
              <div className="flex flex-col overflow-hidden">
                <span className="text-xs font-medium text-white truncate">{s.name}</span>
                <span className="text-[9px] font-normal text-white/40 uppercase tracking-wider">{s.type}</span>
              </div>
            </div>
          </button>
        );
      })}
      </div>
    </div>
  );
};

export default SuggestionDropdown;
